import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_MONTHLY_DISCOUNT, LINE_ITEM_WEEKLY_DISCOUNT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const decimalToNumber = value => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const LineItemLongStayDiscountMaybe = props => {
  const { lineItems, intl } = props;
  const discount = lineItems.find(
    item =>
      !item.reversal &&
      (item.code === LINE_ITEM_WEEKLY_DISCOUNT || item.code === LINE_ITEM_MONTHLY_DISCOUNT)
  );

  if (!discount) {
    return null;
  }

  const isMonthly = discount.code === LINE_ITEM_MONTHLY_DISCOUNT;
  const translationKey = isMonthly
    ? 'OrderBreakdown.monthlyDiscount'
    : 'OrderBreakdown.weeklyDiscount';
  const percentage = Math.abs(decimalToNumber(discount.percentage));
  const total = formatMoney(intl, discount.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id={translationKey} values={{ percentage }} />
      </span>
      <span className={css.itemValue}>{total}</span>
    </div>
  );
};

LineItemLongStayDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemLongStayDiscountMaybe;
